// using module.exports here so gatsby-config can read it

process.env.builderAPIKey = process.env.builderAPIKey || '30c20afa76674ec18dce5c985c862c4b';

process.env.ENABLE_GATSBY_REFRESH_ENDPOINT=1

module.exports = {
  // TODO: uncomment next line and enter your own public API key
  builderAPIKey: process.env.builderAPIKey
};
